import { useContext } from "react";
import {PromoContext} from "../../context/Promo/PromoContext";

export const usePromo = () => useContext(PromoContext);
